import { fillLayers, pick, type LayerStyle } from "./types";

const PARK = "#3b8f4e";

const style: LayerStyle = {
  id: "coa-parks",
  minzoom: 10,
  maxzoom: 15,
  layers(source) {
    return fillLayers(this, source, PARK, 0.3);
  },
  legend: [{ label: "City park, greenbelt or preserve", color: PARK }],
  describe: (p) =>
    pick(p, [
      ["LOCATION_NAME", "Park"],
      ["PARK_TYPE", "Type"],
      ["DEVELOPMENT_STATUS", "Development"],
      ["ACRES", "Acres", (v) => (Number.isFinite(Number(v)) ? Number(v).toFixed(1) : String(v))],
    ]),
};

export default style;
